import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { UPCLAIM_ROLES } from "@upclaim/sdk/src/admin-roles";

import { TASK_STATUSES } from "@/features/tasks/api/use-tasks";
import { CLAIM_PREVIEW_TABS } from "@/features/tasks/components/claim-preview-panel";
import { TaskListPage } from "@/features/tasks/components/task-list-page";
import { useCurrentUser } from "@/hooks/use-current-user";

const allTasksSearchSchema = z.object({
  status: z.enum(TASK_STATUSES).catch("today"),
  claim: z.string().optional().catch(undefined),
  claimTab: z.enum(CLAIM_PREVIEW_TABS).optional().catch(undefined),
  search: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_authed/_dashboard/admin-tools/all-tasks")({
  validateSearch: allTasksSearchSchema,
  component: AllTasksPage,
});

/** Port of AllTasks.vue — Upclaim only, filter=all with cursor pagination. */
function AllTasksPage() {
  const { can } = useCurrentUser();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  if (!can(UPCLAIM_ROLES)) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4">
        <h1 className="text-4xl font-bold">404</h1>
        <p className="text-muted-foreground">Cette page n'existe pas.</p>
      </div>
    );
  }

  return (
    <TaskListPage
      scope="all"
      search={search}
      onSearchChange={(patch, options) =>
        navigate({
          search: (prev) => ({ ...prev, ...patch }),
          replace: options?.replace ?? true,
          resetScroll: false,
        })
      }
    />
  );
}
